import ReactDOM from 'react-dom/client';
import './globals.css';
import { RouterProvider } from 'react-router-dom';
import { routerTree } from './routes/route-tree';
import './i18n/i18n';
import * as Sentry from '@sentry/react';
import { isCurrentHost } from './store/api/utils.ts/stand';

Sentry.init({
  dsn: 'https://507214f1d868b1ef46fbd0c1645b22db@o4509076237320192.ingest.de.sentry.io/4509076323172432',
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['https://informer.center/api'],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.

  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  enabled: isCurrentHost('prod'),
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <RouterProvider router={routerTree} />,
);
